/**
 * Credit card types returned by Stripe
 * https://stripe.com/docs/stripe.js#card-cardType
 * @type {Object}
 */
export const CREDIT_CARD_TYPES = {
  VISA: 'Visa',
  MASTER_CARD: 'MasterCard',
  AMERICAN_EXPRESS: 'American Express',
  DISCOVER: 'Discover',
  DINERS_CLUB: 'Diners Club',
  JCB: 'JCB',
}
